import { Box, Typography, AlertTitle } from '@mui/material'
import React from 'react'
import { routes } from '../../../routes'
import { Link, Alert } from '../../../components'

const styles = {
  alert: { maxWidth: '350px', margin: '0 auto' }
}

export const ErrorLoadingPlan = () => (
  <Alert severity='error' sx={styles.alert}>
    <AlertTitle>Plan not found</AlertTitle>
    <Box display='flex' flexDirection='row'>
      <Typography>
        We couldn&apos;t fetch your selected plan information&nbsp;
        <Link to={routes.b2cFreeRegister.path} underline='always' variant='body1'>
          <strong>Start with free?</strong>
        </Link>
      </Typography>
    </Box>
  </Alert>
)

export const ErrorSigningUp = () => (
  <Alert severity='error' sx={styles.alert}>
    <AlertTitle>Sign up failed</AlertTitle>
    <Box display='flex' flexDirection='row'>
      <Typography>
        We couldn&apos;t sign you up because the email is already in use.
        You can use the&nbsp;
        <Link to={routes['recovery-password'].path} underline='always' variant='body1'><strong>Forgot password</strong></Link>
        &nbsp;tool to regain access to your subscription.
      </Typography>
    </Box>
  </Alert>
)
export const ErrorMultipleSubscriptions = () => (
  <Alert severity='error' sx={styles.alert}>
    <AlertTitle>You already have an active subscription</AlertTitle>
    <Box display='flex' flexDirection='row'>
      <Typography>
        Go to your &nbsp;
        <Link to={routes.profile.path} underline='always' variant='body1'>
          <strong>profile page</strong>
        </Link>
        &nbsp;if you want to update it.
      </Typography>
    </Box>
  </Alert>
)
export const ErrorAlreadySubscribedToPlan = () => (
  <Alert severity='error' sx={styles.alert}>
    <AlertTitle>You are already subscribed to this plan</AlertTitle>
    <Box display='flex' flexDirection='row'>
      <Typography>
        Go to your &nbsp;
        <Link to={routes.profile.path} underline='always' variant='body1'>
          <strong>profile page</strong>
        </Link>
        &nbsp;if you want to update it.
      </Typography>
    </Box>
  </Alert>
)
export const ErrorPayment = () => (
  <Alert severity='error' sx={styles.alert}>
    <AlertTitle>Payment Issue</AlertTitle>
    <Box display='flex' flexDirection='row'>
      <Typography>
        We&apos;re sorry, but there was an issue processing your payment. Please check your payment details and try again. If the problem persists, contact your bank or try using a different payment method.
      </Typography>
    </Box>
  </Alert>
)

export const ErrorPaypal = () => (
  <Alert severity='error' sx={styles.alert}>
    <AlertTitle>Paypal transaction failed</AlertTitle>
    <Box display='flex' flexDirection='row'>
      <Typography>
        Please try again or use a different payment method.
      </Typography>
    </Box>
  </Alert>
)
